/**
 * 建议不引入其他
 */
if(!console){
  window.console = {};
  console.error = ()=>{};
  console.warn = ()=>{};
  console.log = ()=>{};
  console.info = ()=>{};
}

var SERVER = {

    rootVue:null
  , rootAxios:null 
  , axios:null
  , serverLib: {}
  , _serverLib: null
  , key : ""
  , publicData: {}
  , loadingCount:0
  , _loadingCommonFn(status){
    if(status){
      this.loadingCount ++;
      this._loadingFn(true);
    }else {
      this.loadingCount --;
      if(this.loadingCount <= 0){
        this._loadingFn(false);
        this.loadingCount = 0;
      }
    }

  }
  , _loadingFn(){}

  , _errorCommonFn(msg){
    if(this._errorFn){
      this._errorFn(msg);
    }else{
      console.error(msg);
    }
  }
  , _errorFn:null
  , _msgCommonFn(msg){
    if(this._msgFn){
      this._msgFn(msg);
    }else{
      console.info(msg);
    }
  }
  , _msgFn:null
  , set ({ Vue, Axios, serverLib, loading , error , msg , key }) {

    if(Vue){
      SERVER.rootVue = Vue;
    }

    if(Axios){
      SERVER.rootAxios = Axios;
      Axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=utf-8';
      SERVER.axios = SERVER.rootAxios.create({
        timeout: 60000
      });
    }


    if(serverLib){
      SERVER._serverLib = serverLib;
      for (var _key in serverLib) {
        
        if(typeof serverLib[_key][0] === 'string' && serverLib[_key][0].indexOf('candao.')===0){
          
          SERVER.serverLib[_key] = {
            url: "/Action?_name=" + _key
            , data: typeof serverLib[_key][1] === 'object' ? serverLib[_key][1] : {}
          }

          SERVER.serverLib[_key].data.actionName = serverLib[_key][0];
        }else{
          SERVER.serverLib[_key] = {
            url: "/Action?_name=" + _key
              + "&serviceId="+serverLib[_key][0]
              + "&actionId="+serverLib[_key][1]
            , data: typeof serverLib[_key][2] === 'object' ? serverLib[_key][2] : {}
          }
        }
      }
    }

    if(loading && typeof loading == 'function'){
      SERVER._loadingFn = loading;
    }


    error && (SERVER._errorFn = error);
    msg && (SERVER._msgFn = msg);
    key && (SERVER.key = key);


  }
  , _getUrlDataFn ({name='',data={},urlUnit=''}) {

    if(!name){
      console.error("SERVER.js [name]不为能空");
      return false;
    }

    if(!SERVER._serverLib){
      console.error("SERVER.js 未配置 serverLib");
      return false;
    }

    if(!SERVER.serverLib[name]){
      console.error("SERVER.js 不存在serverLib["+name+"]");
      return false;
    }

    if(!SERVER.axios){
      console.error("SERVER.js [axios]未配置");
      return false;
    }

    //6.0接口数据结构处理
    if(SERVER.serverLib[name].data.actionName){
      SERVER.serverLib[name].data = {
        actionName : SERVER.serverLib[name].data.actionName,
      }
      data = {
        content:data,
        ...SERVER.publicData // 设置额外的值
      };

    }

    var urlData = {
      url:SERVER.serverLib[name].url,
      data:{...SERVER.serverLib[name].data,...data}
    }
    if(SERVER.key){
      urlData.url = urlData.url + "&key="+SERVER.key;
    }
    if(SERVER.lang && SERVER.lang != -1){
      urlData.url = urlData.url + "&langType="+SERVER.lang;
    }

    if(urlUnit !== 'Action'){
      urlData.url = urlData.url.replace("/Action","/"+urlUnit);
    }

    if(urlUnit === 'LocalAction'){
      let url_link = urlData.url.split("?");
      urlData.url = url_link[0] + '?method=' + name + '&key=' + SERVER.key;

      if(SERVER.lang && SERVER.lang != -1){
        urlData.url = urlData.url + "&langType="+SERVER.lang;
      }
    }

    return urlData;

  }
  , logs:[]
	, mixin : {
		data(){
      return {
        server:{
          /*
            提供publicData对象，在6.0请求中data里的值都会被设置在content字段中，这个对象是为了能设置在content之外提供的
            这个对象里面的值显示在content对象同级里
          */
          setPublicData(data) { 
            SERVER.publicData = { ...data };
          },
          setKey:function(key){
            
            SERVER.key = key;
          },
          setLang:function(lang){
            
            SERVER.lang = lang;
          },
          get:function({name='',urlUnit='Action',data={},isCheck=false}){

            var urlData = SERVER._getUrlDataFn({name,data,urlUnit});
            if(!urlData){
              return {then(){},catch(){}};
            }

            urlData.data = JSON.stringify(urlData.data);

            return this.require({...urlData, isCheck });
          },
          cache:{
            _require:function(result){
              return _require({url:result.url,data:result.data});
            },
            get:function(name){
              var url = "/Cache?actionId=2";
              if(SERVER.key){
                url+="&key=" + SERVER.key;
              }
              if(SERVER.lang && SERVER.lang != -1){
                url+="&langType=" + SERVER.lang;
              }
              return this._require({url,data:name});
            },
            set:function(data){
              var url = "/Cache?actionId=1";
              if(SERVER.key){
                url+="&key=" + SERVER.key;
              }
              if(SERVER.lang && SERVER.lang != -1){
                url+="&langType=" + SERVER.lang;
              }
              return this._require({url,data});
            },
            check:function(name){
              var url = "/Cache?actionId=3";
              if(SERVER.key){
                url+="&key=" + SERVER.key;
              }
              if(SERVER.lang && SERVER.lang != -1){
                url+="&langType=" + SERVER.lang;
              }
              return this._require({url,data:name});
            }
          },
          require:_require
          
        }
      }
      
    }
	}
};

var _require =  async function({url='',data={},isCheck=false,type = "post"}){
            
  // SERVER._loadingCommonFn(true);
  var promise = SERVER.axios[type](url,data||{}).catch(function (error) {
    SERVER._errorCommonFn("网络异常,请稍后再试 " + url);
    SERVER._loadingCommonFn(false);
    return error;
  }).then(function(result){
    SERVER._loadingCommonFn(false);
    return result.data;
  });

  if(isCheck){
    promise = promise.then(function(result){
      if(!result){
        SERVER._errorCommonFn("SERVER.js 接口无返回内容 " + url);
      }else if(result.status == 1){
        return result.data || {};
        //SERVER._msgCommonFn(result.msg||'操作成功');
        //then && then(result.data);
      }else if(result.msg){
        SERVER._errorCommonFn(result.msg);
      }
      return false;

      
    });
  }else{
    // promise = promise.then(function(result){
    //   return result.data||false;
    // })
  }

  return await promise;


};

export default SERVER;



// WEBPACK FOOTER //
// ./../../plugins/server.js